var _objectSpread = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread");

var _require = require('../primitives'),
    STRING = _require.STRING;

var password = _objectSpread({}, STRING, {
  numbers: function numbers(val, number) {
    return !!val.match(/(\d)/g) && val.match(/(\d)/g).length >= number;
  },
  uppercase: function uppercase(val, number) {
    return !!val.match(/([A-Z])/g) && val.match(/([A-Z])/g).length >= number;
  },
  specialChars: function specialChars(val, number) {
    return !!val.match(/([^a-zA-Z])/g) && val.match(/([^a-zA-Z])/g).length >= number;
  },
  matchesOneOf: function matchesOneOf(val, arr) {
    for (var i = 0; i < arr.length; i += 1) {
      if (val.indexOf(arr[i]) !== -1) {
        return true;
      }
    }

    return false;
  },
  matchesAllOf: function matchesAllOf(val, arr) {
    for (var i = 0; i < arr.length; i += 1) {
      if (val.indexOf(arr[i]) === -1) {
        return false;
      }
    }

    return true;
  }
});

module.exports = password;